import { render, staticRenderFns } from "./CmgIngredientsBanner.vue?vue&type=template&id=50970888&scoped=true&lang=pug&"
import script from "./cmg-ingredients-banner.ts?vue&type=script&lang=ts&"
export * from "./cmg-ingredients-banner.ts?vue&type=script&lang=ts&"
import style0 from "./CmgIngredientsBanner.vue?vue&type=style&index=0&id=50970888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50970888",
  null
  
)

export default component.exports